import { Component, Input, OnInit } from '@angular/core';
import { FilePreview } from '@ca/core/models';
import { FilePreviewService } from '@ca/core/services';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'ca-file-previewer',
    templateUrl: './file-previewer.component.html',
    styleUrls: ['./file-previewer.component.scss'],
})
export class FilePreviewerComponent implements OnInit {
    @Input() data?: string;
    @Input() set type(type: string) {
        this._type = type;
        switch (this.type) {
            case 'txt':
            case 'csv':
            case 'json':
                this.isSupportedType = true;
                break;
            default:
                this.isSupportedType = false;
        }
    }
    get type(): string {
        return this._type;
    }

    isSupportedType = false;

    private _type: string;

    constructor(private readonly filePreviewService: FilePreviewService) {}

    ngOnInit(): void {
        // If the data attribute is not provided, it might be that the data comes from the observable in FilePreviewService (for inline display)
        if (this.data == null) {
            this.filePreviewService.inlineContent$
                .pipe(
                    tap((data: FilePreview) => {
                        this.data = data.content;
                        this.type = data.type;
                    }),
                    untilDestroyed(this),
                )
                .subscribe();
        }
    }
}
